import { BASKET_TYPES, selectBasketItem, selectBasketList } from 'containers/OrderDetails/basketSlice'
import React, { useEffect, useRef, useState } from 'react'
import useWarehouseName from 'hooks/useWarehouseName'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'

const HeaderTitle: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const list = useReduxSelector(selectBasketList)
  const item = useReduxSelector(state => selectBasketItem(state, id))
  const [basketAlert, showBasketAlert] = useState(false)
  const previousWarehousesAmount = useRef(0)

  const getName = useWarehouseName()
  const { t } = useTranslation('basket')

  useEffect(() => {
    const warehousesAmount = list.reduce((r: number, e: { type: string }) => r += e.type === BASKET_TYPES.rent ? 1 : 0, 0)
    if (warehousesAmount > previousWarehousesAmount.current) {
      showBasketAlert(true)
    }
    previousWarehousesAmount.current = warehousesAmount
  }, [list])

  useEffect(() => {
    if (basketAlert) {
      const timeout = setTimeout(() => { showBasketAlert(false) }, 3000)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [basketAlert])

  return (
    previousWarehousesAmount.current > 0
      ? basketAlert
        ? <div className='header__title --animated'>
          <div className='--sb'>{t(item?.rentableType === 'parking' ? 'parkingWasReservedFor3Minutes' : 'warehouseWasReservedFor3Minutes')}</div>
        </div>
        : <div className='header__title'>
          <div className='--sb'>{getName(item)}</div>
          <div>{item?.placeAddress}</div>
        </div>
      : null
  )
}

export default HeaderTitle